module.exports = __webpack_public_path__ + "assets/img/default_thumb.97741453.png";